export const redirectCheckoutUrl = (cruiseCode: string, checkoutId: string) => `/api/${cruiseCode}/${checkoutId}`

export const paymentUrl = (cruiseCode: string, checkoutId: string) =>
    `/v3/${cruiseCode}/payment?checkout=${checkoutId}&is-redirect=true`
